import _ from 'lodash';
import angular from 'angular';
import Logger from '../../../shared/logger';

export class RecruiterSearchComponent {
    /* @ngInject */
    constructor(
        $scope,
        $state,
        $stateParams,
        $q,
        CandidateService,
        NotificationService,
        PositionService,
        RecruiterService,
        RECRUITER_WORKFLOW_STATUS,
        RecruiterCandidateService,
        RouteService,
        WorkflowService,
    ) {
        $scope.claimCandidate = function (candidate, afterClaimCallback, canClaim) {
            if (!canClaim) {
                NotificationService.error('You have reached the maximum number of claimed candidates');
                return;
            }
            if ($scope.isClaiming) {
                return;
            }
            $scope.isClaiming = true;
            CandidateService.postCandidateSearch({ talentId: [candidate.talentId] })
                .then((response) => {
                    if (response.result.length > 0) {
                        const candidateId = response.result[0]._id;
                        WorkflowService.getWorkflowSearch({
                            positionId: $stateParams.positionId,
                            recruiterId: $stateParams.recruiterId,
                            talentId: candidate.talentId,
                        })
                            .then((response) => {
                                if (response.result.length > 0) {
                                    const workflow = _.find(response.result, workflow => workflow.recruiterStatus.current === 'Prospect');

                                    if (workflow && workflow._id) {
                                        WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                                            status: 'Claimed',
                                            reason: 'N/A',
                                        })
                                            .then((response) => {
                                                candidate.workflow = response.result;
                                                afterClaimCallback();
                                            })
                                            .catch(error => Logger.error(error));
                                    }
                                } else {
                                    $scope.addWorkflow(candidateId, candidate, afterClaimCallback);
                                }
                            })
                            .catch(error => Logger.error(error));
                    } else {
                        CandidateService.postCandidate({
                            talentId: candidate.talentId,
                        })
                            .then((response) => {
                                $scope.addWorkflow(response.result._id, candidate, afterClaimCallback);
                            })
                            .catch(error => Logger.error(error));
                    }
                    NotificationService.success('CANDIDATE_HAS_BEEN_CLAIMED');
                })
                .catch(error => {
                    Logger.error(error);
                    NotificationService.error('CANDIDATE_CLAIM_ERROR');
                });
        };

        $scope.bulkClaimCandidates = async function ({ candidates }) {
            const talentIds = _.map(candidates, 'talentId');

            return RecruiterCandidateService.bulkClaimCandidates({
                talentIds,
                positionId: $scope.positionData._id,
                recruiterId: $stateParams.recruiterId,
            });
        };

        $scope.hideCandidate = function (candidate, afterHideCallback) {
            CandidateService.postCandidateSearch({ talentId: [candidate.talentID || candidate.talentId] })
                .then((response) => {
                    if (response.result.length > 0) {
                        const candidateId = response.result[0]._id;
                        const recruiterId = _.get($scope, 'recruiterCtrl.recruiterData._id') || _.get($scope, 'data.recruiterId');
                        WorkflowService.getWorkflowSearch({
                            positionId: $stateParams.positionId,
                            recruiterId: recruiterId,
                            talentId: candidate.talentID || candidate.talentId,
                        })
                            .then((response) => {
                                if (response.result.length > 0) {
                                    const workflow = _.find(response.result, workflow => workflow.recruiterStatus.current === 'Prospect');
                                    WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                                        status: 'Hidden',
                                        reason: 'N/A',
                                    })
                                        .then(() => afterHideCallback())
                                        .catch(error => Logger.error(error));
                                } else {
                                    const deffered = $q.defer();
                                    $scope.addWorkflow(candidateId, candidate, null, deffered)
                                        .then((workflow) => {
                                            if (workflow) {
                                                WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                                                    status: 'Hidden',
                                                    reason: 'N/A',
                                                })
                                                    .then((response) => {
                                                        candidate.workflow = response.result;
                                                        afterHideCallback();
                                                    })
                                                    .catch(error => Logger.error(error));
                                            }
                                        })
                                        .catch(error => Logger.error(error));
                                }
                            })
                            .catch(error => Logger.error(error));
                    } else {
                        CandidateService.postCandidate({
                            talentId: candidate.talentID || candidate.talentId,
                        })
                            .then((response) => {
                                const deffered = $q.defer();
                                $scope.addWorkflow(response.result._id, candidate, null, deffered)
                                    .then((workflow) => {
                                        if (workflow) {
                                            WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                                                status: 'Hidden',
                                                reason: 'N/A',
                                            })
                                                .then((response) => {
                                                    candidate.workflow = response.result;
                                                    afterHideCallback();
                                                })
                                                .catch(error => Logger.error(error));
                                        }
                                    })
                                    .catch(error => Logger.error(error));
                            })
                            .catch(error => Logger.error(error));
                    }
                    NotificationService.success('SEARCH_CANDIDATE_HAS_BEEN_REMOVED');
                })
                .catch(error => Logger.error(error));
        };

        $scope.addWorkflow = function (candidateId, candidate, openCandidates, deffered) {
            WorkflowService.postWorkflow({
                recruiterId: $stateParams.recruiterId,
                candidateId,
                talentId: candidate.talentID || candidate.talentId,
                positionId: $stateParams.positionId,
                employerId: $scope.positionData.employerId,
                employerRepId: $scope.positionData.employerId,
                title: $scope.positionData.jobTitle,
                dueDate: '2017-01-01',
            })
                .then((response) => {
                    candidate.workflow = response.result;
                    if (deffered) {
                        deffered.resolve(candidate.workflow);
                        return;
                    }
                    openCandidates();
                }, () => {
                    if (deffered) {
                        deffered.resolve(null);
                    }
                })
                .catch(error => Logger.error(error));
            if (deffered) {
                return deffered.promise;
            }
        };

        $scope.addNote = function (candidate, noteData) {
            const deferred = $q.defer();
            if (!candidate.workflow) {
                CandidateService.postCandidateSearch({ talentId: [candidate.talentID || candidate.talentId] })
                    .then((response) => {
                        if (response.result.length > 0) {
                            deferred.resolve(response.result[0]._id);
                        } else {
                            CandidateService.postCandidate({
                                talentId: candidate.talentID || candidate.talentId,
                            })
                                .then((response) => {
                                    deferred.resolve(response.result._id);
                                })
                                .catch(error => Logger.error(error));
                        }
                    })
                    .catch(error => Logger.error(error));
            } else {
                deferred.resolve(candidate.workflow.candidateId);
            }
            deferred.promise.then((candidateId) => {
                if (noteData.type == 'note') {
                    CandidateService.postCandidateNote(candidateId, {
                        positionId: $stateParams.positionId,
                        recruiterId: $stateParams.recruiterId,
                        content: noteData.text,
                    })
                        .then((response) => {
                            candidate.notes = candidate.notes || [];
                            candidate.notes.push(response.result);
                        })
                        .catch(error => Logger.error(error));
                } else if (noteData.type == 'comment') {
                    CandidateService.postCandidateComment(candidateId, {
                        positionId: $stateParams.positionId,
                        recruiterId: $stateParams.recruiterId,
                        content: noteData.text,
                    })
                        .then((response) => {
                            candidate.comments.push(response.result);
                        })
                        .catch(error => Logger.error(error));
                }
            })
                .catch(error => Logger.error(error));
        };

        $scope.getNotes = function (candidate) {
            CandidateService.postCandidateSearch({ talentId: [candidate.talentID || candidate.talentId] })
                .then((response) => {
                    const resultLength = _.get(response,'result.length',0);
                    if (resultLength) {
                        CandidateService.getCandidateNotes(response.result[0]._id)
                            .then((response) => {
                                candidate.notes = _.filter(response.result, note => note.recruiterId == $stateParams.recruiterId);
                            })
                            .catch(error => Logger.error(error));

                        CandidateService.getCandidateComments(response.result[0]._id)
                            .then((response) => {
                                candidate.comments = _.filter(response.result, (comment) => {
                                    if (comment.recruiterId) {
                                        return true;
                                    }
                                    return false;
                                })
                                if (candidate.comments.length > 0) {
                                    RecruiterService.postRecruiterSearch({ recruiterIDs: _.map(candidate.comments, 'recruiterId') })
                                        .then((response) => {
                                            for (let j = 0; j < candidate.comments.length; j++) {
                                                for (let i = 0; i < response.result.length; i++) {
                                                    if (candidate.comments[j].recruiterId == response.result[i]._id) {
                                                        candidate.comments[j].recruiterData = response.result[i].fullName;
                                                        break;
                                                    }
                                                }
                                            }
                                        })
                                        .catch(error => Logger.error(error));
                                }
                            })
                            .catch(error => Logger.error(error));
                    } else {
                        candidate.notes = [];
                        candidate.comments = [];
                    }
                })
                .catch(error => Logger.error(error));
        };
        $scope.refreshSearch = function (claimedByOtherRecruiters) {
            $state.go('recruiter.search', {
                claimedByOtherTE: claimedByOtherRecruiters,
            }, {
                reload: 'recruiter.search',
            });
        };
        $scope.numberOfCandidatesToSearch = RouteService.getSystemDefaults('NumberOfCandidatesToSearch');
        PositionService.getPosition($stateParams.positionId)
            .then((response) => {
                $scope.positionData = response.result;
                $scope.data = {
                    recruiterId: $stateParams.recruiterId,
                    positionId: $stateParams.positionId,
                    currSearchHistoryIndex: $stateParams.history.value || 1,
                    showResults: ($scope.numberOfCandidatesToSearch || 400) + parseInt($stateParams.claimedByOtherTE.value || 0),
                    currCandidatePage: $stateParams.page.value || 1,
                    talentID: $stateParams.talentID.value || null,
                    scroll: $stateParams.scroll.value || 0,
                    searchName: $stateParams.searchName.value || null,
                    showView: 'MainSearch',
                    candidatesName: $stateParams.candidatesName.value || 0,
                    claimCandidate: $scope.claimCandidate,
                    bulkClaimCandidates: $scope.bulkClaimCandidates,
                    hideCandidate: $scope.hideCandidate,
                    addNote: $scope.addNote,
                    getNotes: $scope.getNotes,
                    positionData: $scope.positionData,
                    refreshSearch: $scope.refreshSearch,
                    backToProspects: (candidate) => {
                        const reason = 'N/A';

                        return WorkflowService.putRecruiterWorkflowStatus(candidate.workflow._id, {
                            status: RECRUITER_WORKFLOW_STATUS.PROSPECT,
                            reason,
                        });
                    },
                };
            })
            .catch(error => Logger.error(error));
    }
}

export const RecruiterSearchComponentConfiguration = {
    template: '<search-component-new ng-if="data" search-data="data"></search-component-new>',
    controller: RecruiterSearchComponent,
};

angular.module('TALENYA-FE').component('recruiterSearchNew', RecruiterSearchComponentConfiguration);